import { getVerifationToken } from "features/analysis";

export const getShareIdTokenAndApplicantId = async (userType: string) => { // SHARE ID TOKEN
    try {
        const token = await getVerifationToken(userType);
        return {
            token: token.data.token ?? "",
            applicant_id: token.data.applicant_id ?? "",
        };
    } catch (error: any) {
        // console.error(error);
        return null;
    }
};
